import { NotificationsRounded } from '@mui/icons-material';
import { Badge } from '@mui/material';
import React, { Fragment } from 'react'
import { withRouter } from 'react-router-dom'

import { createTheme, ThemeProvider } from '@mui/material/styles';

function Fecha(props) {

    const theme = createTheme({
        palette: {
            neutral: {
                main: '#64748B',
                contrastText: '#fff',
            },
        },
    });



    let stat = props.status

    const solicitudes = props.datos;

    React.useEffect(() => {
        solicitudes
    }, [solicitudes])

    return (
        <Fragment>
            <div className='col-sm-12 col-md-8 col-lg-8 col-xl-8 col-xxl-8' style={stat === 1 ? { backgroundColor: '#EAECEE', color: "black" } : stat === 2 ? { backgroundColor: '#FCF3CF', color: "black" } : stat === 3 ? { backgroundColor: '#FAD7A0', color: "black" } : stat === 4 ? { textAlign: 'right', backgroundColor: '#AED6F1', color: "black" } : stat === 5 ? { backgroundColor: '#A9DFBF', color: "black" } : { backgroundColor: '#EAECEE', color: "black" }}>
                <br />
                {
                    solicitudes.length > 0 ?
                        <Badge badgeContent={solicitudes.length} color="error">
                            <NotificationsRounded style={{ fontSize: "2.2em" }} />
                        </Badge>
                        :
                        <ThemeProvider theme={theme}>
                            <Badge badgeContent={0} showZero color="neutral" >
                                <NotificationsRounded style={{ fontSize: "2.2em" }} />
                            </Badge>
                        </ThemeProvider>
                }
            </div>
        </Fragment>
    );
};


export default withRouter(Fecha)